import { render, staticRenderFns } from "./HighCostSeparated.vue?vue&type=template&id=94f5e10a&scoped=true&"
import script from "./HighCostSeparated.vue?vue&type=script&lang=ts&"
export * from "./HighCostSeparated.vue?vue&type=script&lang=ts&"
import style0 from "./HighCostSeparated.vue?vue&type=style&index=0&id=94f5e10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f5e10a",
  null
  
)

export default component.exports